import { isValidMonthAbbr } from '@exam-center/exam-event-management';
import { ExamEventScheduleModalProvider } from '@exam-center/exam-event-schedule';
import { Navigate, useParams } from '@exam-center/router';
import { dayjs } from '@shared/utils';

export default function MonthlyExamScheduleLayout() {
  const { examCenterCode, year, month } = useParams(
    '/:examCenterCode/exam-events/years/:year/months/:month',
  );

  if (!isValidMonthAbbr(month)) {
    const currentMonth = dayjs().locale('en').format('MMM').toUpperCase();

    return (
      <Navigate
        to='/:examCenterCode/exam-events/years/:year/months/:month'
        replace
        params={{ month: currentMonth, year, examCenterCode }}
      />
    );
  }

  return <ExamEventScheduleModalProvider />;
}
